import React, { useState, useRef } from 'react';
import {
  Typography,
  makeStyles,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Divider,
} from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '20px',
    textDecoration: 'none',
    padding: '6px 20px 10px',
    color: theme.palette.midGrey.main,
    transition: '0.2s',
    cursor: 'pointer',
    '& span': { fontSize: '12px' },
    '&:hover': {
      color: (props) => props.textColor,
      backgroundColor: (props) => props.backgroundColor,
      transition: '0.1s',
    },
  },
  arrow: {
    fontSize: '10px',
    transition: 'transform 0.2s',
  },
  arrowOpen: {
    transform: 'rotate(180deg)',
  },
  paper: {
    width: '382px',
    marginTop: '8px',
    borderRadius: '16px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  menuItem: {
    fontSize: '14px',
    fontFamily: 'Nunito',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    padding: '24px 20px',
    width: '100%',
    justifyContent: 'center',
    color: '#66647A',
    '&:hover': {
      backgroundColor: (props) => props.backgroundColor,
      color: (props) => props.textColor,
    },
    '&:focus': {
      borderRadius: '16px',
    },
  },
}));

const TopNavLinkWithSubmenu = ({
  label,
  backgroundColor,
  textColor,
  items,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const classes = useStyles({ backgroundColor, textColor });

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleItemClick = (event, to) => {
    handleClose(event);
    window.location.href = to;
  };

  return (
    <>
      <span
        ref={anchorRef}
        onClick={handleToggle}
        className={classes.root}
      >
        <Typography variant="button">{label}</Typography>
      </span>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom"
        style={{ zIndex: 1001 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
            <Paper className={classes.paper}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList style={{ width: '100%', padding: 0 }}>
                  {items.map((item, index) => (
                    <React.Fragment key={item.label}>
                      {index > 0 && <Divider style={{ backgroundColor: '#66647A', margin: '0 20px' }} />}
                      <MenuItem
                        className={classes.menuItem}
                        onClick={(e) => handleItemClick(e, item.to)}
                      >
                        {item.label}
                      </MenuItem>
                    </React.Fragment>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

TopNavLinkWithSubmenu.propTypes = {
  label: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default TopNavLinkWithSubmenu;
